// @atlas/contracts — a `global-search` modul Zod-sémái
//
// A fájl CSAK sémákat tart (érték-szintű Zod-objektumok + a belőlük inferált típusok) — a ROUTE-ok
// egyetlen `atlasContract` objektum-literálban maradnak (`src/index.ts`), mert a ts-rest
// kontextus-inferenciája a lapos bővítésre érzékeny. A sémák mozgatása ezt NEM érinti: sima értékek.
import { z } from 'zod';
// ── Globális kereszt-entitás kereső (command palette) ──
/**
 * A globális kereső találat-típusai (a menüpontokhoz igazítva). A `type` vezérli a WEB-oldali navigációs
 * célt (route/sheet/lista) — a BFF ROUTING-agnosztikus: csak `{ type, id, label, sublabel }`-t ad, a
 * cél-feloldás a kliens dolga. Minden típus a SAJÁT `.view` jogához kötött (a BFF per-típus gate-el).
 */
export const GLOBAL_SEARCH_TYPES = [
    'client',
    'account',
    'contact',
    'ticket',
    'invoice',
    'expense',
    'message',
    'meeting',
    'employee',
    'supportTeam',
    'asset',
    'serviceAssignment',
    'serviceCatalog',
    'campaign',
    'productUpdate',
    'department',
    'team',
    'position',
];
/** Egy kereső-találat: lapos, routing-agnosztikus alak (a `type` vezérli a kliens-oldali célt). */
export const GlobalSearchResultSchema = z.object({
    type: z.enum(GLOBAL_SEARCH_TYPES),
    id: z.string(),
    /** Ember-olvasható elsődleges címke (pl. név / számlaszám / tárgy). */
    label: z.string(),
    /** Opcionális másodlagos címke (pl. ügyfél-név / e-mail / állapot) — hiányozhat. */
    sublabel: z.string().nullable().optional(),
});
/**
 * A kereső query-paraméterei: a keresett kifejezés (üres / túl rövid → üres eredmény a BFF-ben) + a hívó
 * nyelve. A `lang` a SZEMÉLY-találatok (munkatárs, kapcsolattartó) névsorrendjét dönti el — magyarul
 * `Vezetéknév Keresztnév`, angolul `Given Family` (a `personName` helper, mint a lista-oldalakon).
 */
export const GlobalSearchQuerySchema = z.object({
    q: z.string(),
    lang: z.enum(['hu', 'en']).optional(),
});
/** A kereső válasza: lapos találat-lista (a `type`-mezővel — a web csoportosít/route-ol). */
export const GlobalSearchResponseSchema = z.object({
    results: z.array(GlobalSearchResultSchema),
    /**
     * A találat-lista NEM teljes: vagy egy típus pásztázása a lap-plafonba ütközött (több sor van, mint
     * amennyit a BFF végignézett), vagy egy típus lekérése hibázott/fojtásba futott, és best-effort kimaradt.
     *
     * MIÉRT VAN A SZERZŐDÉSBEN: a kereső korábban mindkét esetben NÉMÁN adott kevesebbet, 200-as válasszal —
     * a felhasználó azt hihette, hogy amit keres, nem is létezik. Élőben mérve: a lap-plafon miatt a számlák
     * 64%-a nem volt megtalálható, a fojtás pedig a 8. keresés után csendben tizedelte a találatokat.
     */
    partial: z.boolean(),
});
//# sourceMappingURL=schemas.js.map